import React from 'react';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const TrashSection = ({
  trashItems,
  trashLoading,
  onRestore,
  onPermanentDelete,
  onEmpty,
  onClose,
  token,
}) => {
  return (
    <div data-testid="trash-section" style={{ marginBottom: 24, padding: 20, backgroundColor: 'rgba(212,175,55,0.03)', border: '1px solid rgba(212,175,55,0.1)', borderRadius: 10 }}>
      <style>{`@keyframes trashPulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.08); } }`}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <span style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37' }}>
          Corbeille ({trashItems.length})
        </span>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {trashItems.length > 0 && (
            <button
              data-testid="empty-trash-btn"
              onClick={onEmpty}
              style={{
                fontFamily: "'Georgia', serif", fontSize: 11, cursor: 'pointer',
                color: 'rgba(180,60,60,0.7)', backgroundColor: 'transparent',
                border: '1px solid rgba(180,60,60,0.2)', borderRadius: 6, padding: '4px 12px',
                transition: 'all 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(180,60,60,0.1)'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              Vider la corbeille
            </button>
          )}
          <button
            data-testid="close-trash-btn"
            onClick={onClose}
            style={{
              fontFamily: "'Georgia', serif", fontSize: 11, cursor: 'pointer',
              color: '#D4AF37', backgroundColor: 'transparent',
              border: '1px solid rgba(212,175,55,0.1)', borderRadius: 6, padding: '4px 10px',
              transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: 4,
            }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.06)'; e.currentTarget.style.color = 'rgba(212,175,55,0.7)'; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = 'rgba(212,175,55,0.5)'; }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
            Fermer
          </button>
        </div>
      </div>
      {trashLoading ? (
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37', textAlign: 'center' }}>Chargement...</p>
      ) : trashItems.length === 0 ? (
        <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37', textAlign: 'center', fontStyle: 'italic' }}>La corbeille est vide</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
          {trashItems.map(item => {
            const isUrgent = item.days_left <= 3;
            const isWarning = item.days_left <= 7 && !isUrgent;
            return (
            <div key={item.id} data-testid={`trash-item-${item.id}`} style={{
              position: 'relative', borderRadius: 10, overflow: 'hidden',
              backgroundColor: 'rgba(0,0,0,0.4)',
              border: isUrgent ? '1.5px solid rgba(231,76,60,0.5)' : '1px solid rgba(212,175,55,0.08)',
              boxShadow: isUrgent ? '0 0 12px rgba(231,76,60,0.15)' : 'none',
              transition: 'all 0.3s',
            }}>
              {/* Miniature */}
              <div style={{ width: '100%', height: 120, backgroundColor: 'rgba(0,0,0,0.6)', position: 'relative', overflow: 'hidden' }}>
                {item.thumbnail_url ? (
                  <img
                    src={`${API}${item.thumbnail_url.replace('/api', '')}?token=${token}`}
                    alt={item.caption || 'Souvenir'}
                    onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                ) : null}
                <div style={{
                  display: item.thumbnail_url ? 'none' : 'flex',
                  width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center',
                  position: item.thumbnail_url ? 'absolute' : 'relative', top: 0, left: 0,
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(212,175,55,0.2)" strokeWidth="1.5">
                    {item.type === 'photo' ? (
                      <><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></>
                    ) : (
                      <><rect x="2" y="2" width="20" height="20" rx="2"/><polygon points="10 8 16 12 10 16"/></>
                    )}
                  </svg>
                </div>

                {/* Badge J-X */}
                <div data-testid={`trash-countdown-${item.id}`} style={{
                  position: 'absolute', top: 6, right: 6,
                  padding: isUrgent ? '4px 10px' : '3px 8px',
                  borderRadius: 20,
                  backgroundColor: isUrgent ? 'rgba(231,76,60,0.9)' : isWarning ? 'rgba(243,156,18,0.85)' : 'rgba(212,175,55,0.6)',
                  color: '#FAF3E0',
                  fontFamily: "'Georgia', serif",
                  fontSize: isUrgent ? 12 : 10,
                  fontWeight: isUrgent ? 700 : 600,
                  letterSpacing: 0.5,
                  animation: isUrgent ? 'trashPulse 1.5s ease-in-out infinite' : 'none',
                  boxShadow: isUrgent ? '0 0 8px rgba(231,76,60,0.4)' : 'none',
                }}>
                  J-{item.days_left}
                </div>
              </div>

              {/* Info + Actions */}
              <div style={{ padding: '8px 10px' }}>
                <p style={{
                  fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0',
                  margin: '0 0 8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                  {item.caption || (item.type === 'photo' ? 'Photo' : 'Video')}
                </p>
                <div style={{ display: 'flex', gap: 4 }}>
                  <button
                    data-testid={`restore-${item.id}`}
                    onClick={() => onRestore(item)}
                    style={{
                      flex: 1, fontFamily: "'Georgia', serif", fontSize: 10, cursor: 'pointer',
                      color: '#D4AF37', backgroundColor: 'rgba(212,175,55,0.08)',
                      border: '1px solid rgba(212,175,55,0.2)', borderRadius: 5, padding: '4px 6px',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.15)'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.08)'}
                  >
                    Restaurer
                  </button>
                  <button
                    data-testid={`perma-delete-${item.id}`}
                    onClick={() => onPermanentDelete(item)}
                    style={{
                      flex: 1, fontFamily: "'Georgia', serif", fontSize: 10, cursor: 'pointer',
                      color: 'rgba(180,60,60,0.8)', backgroundColor: 'transparent',
                      border: '1px solid rgba(180,60,60,0.15)', borderRadius: 5, padding: '4px 6px',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(180,60,60,0.1)'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
            );
          })}
        </div>
      )}
      <p style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: '#D4AF37', textAlign: 'center', marginTop: 12, fontStyle: 'italic' }}>
        Les elements sont conserves 30 jours avant suppression definitive
      </p>
    </div>
  );
};

export default TrashSection;
